import { render } from "./ModalTPServicos.vue?vue&type=template&id=4ec5cedc"
import script from "./ModalTPServicos.vue?vue&type=script&lang=js"
export * from "./ModalTPServicos.vue?vue&type=script&lang=js"

import "./ModalTPServicos.vue?vue&type=style&index=0&id=4ec5cedc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__